export default "__VITE_ASSET__DDZRsP$3__"